<template>
    <div class="container">
        <div class="center">
            <h1>About KROZ</h1>
            <h3 style="text-align: justify; margin: auto; width: 80%;">
                KROZ is a text-based adventure game. 
                Explore 8 chapters filled with puzzles, combat, and treasure hunting.
                <br/><br/>
                <strong>Offline Play:</strong> The entire game is loaded in your browser and works completely offline. 
                Once loaded, you can play on a train, plane, or anywhere without internet connection. 
                The game data is intentionally accessible in the console for debugging and educational purposes.
                <br/><br/>
                <strong>Features:</strong>
                <ul style="text-align: left; display: inline-block;">
                    <li>8 complete chapters with coherent storyline</li>
                    <li>Combat system with weapons and status effects</li>
                    <li>Puzzle solving with keys and mechanisms</li>
                    <li>Auto-save between chapters</li>
                    <li>Manual save/load system</li>
                    <li>Compass and map navigation</li>
                </ul>
                <br/>
                Type <code>help</code> in-game for all available commands.
            </h3><br />
            <h3>Click BACK then PLAY to start your adventure!</h3>
            <br />
            <nav>
                <button><router-link to="/" style="font-size: 20px;">BACK</router-link></button>&nbsp;
                <button><router-link to="/roadmap" style="font-size: 20px;">ROADMAP</router-link></button>
            </nav>
            <p style="vertical-align: bottom !important;">Made with ❤️ by<br /><br /><a
                    href="https://madeddu.xyz">madeddu.xyz</a></p>
            <p><a href="https://www.buymeacoffee.com/made2591">buy me a coffee</a></p>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'AboutView',
    // You can add component-specific data, methods, etc. here
}
</script>